import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiPartnerValues extends Layout {
    panelPartnerValues: Panel;
    sourceSegAllocControl: DataSource;
    sourceViewEdiOrder: DataSource;
    textboxCustomerEdiloc: Textbox;
    textboxEdiCommodityId: Textbox;
    textboxEdiEquipTypeId: Textbox;
    textboxEdiOrderTypeId: Textbox;
    textboxEdiRevenueCode: Textbox;
    textboxEdiSegAllocCode: Textbox;
}
